import { outline } from './outliner_worker';

export interface Outline {
    points: number[][];
    totalPoints: number[][];
    boundsX: number;
    boundsY: number;
    boundsWidth: number;
    boundsHeight: number;
}

function fn2workerURL(fn: Function) {
    var blob = new Blob(['(' + fn.toString() + ')()'], { type: 'application/javascript' });
    return URL.createObjectURL(blob);
}

export function findOutlines(
    image: HTMLImageElement,
    callback: (outlines: { success: boolean; error?: string; outlines: Outline[]; width: number; height: number }) => void
) {
    let w = new Worker(fn2workerURL(outline));

    // Resize max 1500px
    let imgWidth = image.width;
    let imgHeight = image.height;
    let maxSize = 2048;

    if (imgWidth > imgHeight && imgWidth > maxSize) {
        let ratio = imgWidth / maxSize;
        imgWidth = imgWidth / ratio;
        imgHeight = imgHeight / ratio;
    } else if (imgHeight > maxSize) {
        let ratio = imgHeight / maxSize;
        imgWidth = imgWidth / ratio;
        imgHeight = imgHeight / ratio;
    }

    // Get image data
    let canvas = document.createElement('canvas');
    canvas.width = imgWidth;
    canvas.height = imgHeight;

    //document.body.appendChild(canvas);

    let ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Failed getting context 2D');

    ctx.drawImage(image, 0, 0, imgWidth, imgHeight);

    let imageData = ctx.getImageData(0, 0, imgWidth, imgHeight);

    w.onmessage = function (e) {
        console.log('Received from web worker %o', e);

        // Error
        if (e.data == false) callback({ ...e.data, width: 0, height: 0 });
        else callback({ ...e.data, width: imgWidth, height: imgHeight });
    };

    w.postMessage(imageData);
}
